import React from "react";
import PropTypes from "prop-types";
import { Table, TableHead, TableRow, TableCell, TableBody } from "@mui/material";

export const InfoTable = ({ title, fields}) => {
  const safeKey = (title || "table").replace(/\s+/g,"_").toLowerCase() // used to generate unique React keys

  return (
    <Table sx={{ tableLayout: "fixed", width: "100%" }}>
      <TableHead>
        <TableRow>
          <TableCell
            colSpan={2}
            sx={{ fontWeight: "bold", textAlign: "center" }}
          >
            {title}
          </TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {fields.map((field, index) => (
          <TableRow
            key={`${safeKey}-${field.label}-${index}`}
            sx={{
              backgroundColor: index % 2 === 0 ? "grey.100" : "white",
            }}
          >
            <TableCell sx={{ fontWeight: "bold", width: "40%" }}>
              {field.label}
            </TableCell>
            <TableCell>{field.value}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

InfoTable.propTypes = {
  title: PropTypes.string,
  fields: PropTypes.array.isRequired,
  tableKey: PropTypes.string
};
